module.exports = __webpack_public_path__ + "assets/img/qrcode.0650d3a9.png";